import { Directive, Input, WritableSignal, OnChanges, HostBinding } from '@angular/core';
import { IActionConfig } from '../action-center/interfaces';

@Directive({
	selector: '[actionCenterLinkEntities]',
})
export class ActionCenterLinkEntitiesDirective implements OnChanges {
	@Input() activeConfigAndClass: {
		activeConfig: WritableSignal<IActionConfig>;
		containerClass: boolean;
	};
	@HostBinding('class.link-config') linkConfigClass: boolean = false;
	@HostBinding('class.link-selection-wrapper') linkSelectionWrapperClass: boolean = false;

	entityLinkers: string[] = ['work_order', 'assets', 'files', 'request', 'incident'];

	ngOnChanges() {
		this.checkIfLinkConfig();
	}

	private checkIfLinkConfig() {
		if (!this.activeConfigAndClass.activeConfig) {
			return this.updateClass(false);
		}

		if (this.entityLinkers.includes(this.activeConfigAndClass.activeConfig.name)) {
			return this.updateClass(true);
		}
		return this.updateClass(false);
	}

	private updateClass(linkConfig: boolean): void {
		this.linkConfigClass = false;
		this.linkSelectionWrapperClass = false;
		if (linkConfig && this.activeConfigAndClass.containerClass) {
			this.linkConfigClass = true;
			return;
		}
		if (linkConfig && !this.activeConfigAndClass.containerClass) {
			this.linkSelectionWrapperClass = true;
			return;
		}
	}
}
